import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    DivFormEstudo,
    DivOverflowXTabelaPadrao,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1sm2xs2,
    GridItem2,
    GridItem3,
    GridItem4,
    GridItem6,
    GridItem8,
    GridItem9,
    GridItem10,
    GridItem11,
    GridItem11sm10xs10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

 import {
    CardGridEstudo,
    CardGridDivHeaderDestaque1,
    CardGridDivH4Destaque,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    ButtonDetalhesCotacaoSeguroVidaSucessaoVitalicia,
    ButtonVisualizarGrafico,
    ButtonVisualizarTabela,
    ButtonDetalhesCalculo,
} from '../../../business-components/Button/Button'

import {
    IconButtonExpandMoreLess,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    pesquisaList,
    pesquisaIndexList,
} from '../../../business-rules/List/ListService'

import {
    AIFT
} from '../aiFT-form/AIFTComp'

import {
    existeTabelaEvolucaoValorResgate,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'

import AcompanhamentoFormSeguroVida from '../acompanhamento-form/AcompanhamentoFormSeguroVida'

import EstudoFormHelp from './EstudoFormHelp'



export const GridContainerEstudoPadraoMd = ( {component} ) => {

    return (
        <GridContainer
            className='justify-center'
        >
            <GridItem9>
                {component}
            </GridItem9>
        </GridContainer>
    )
}

export const GridContainerEstudoPadraoLg = ( {component} ) => {

    return (
        <GridContainer
            className='justify-center'
        >
            <GridItem11>
                {component}
            </GridItem11>
        </GridContainer>
    )
}

export const IconButtonExpandMoreLessLista = ( {nameListaMoreLess, listaMoreLess, idListaMoreLess, setFieldValue} ) => {

    return (
        <IconButtonExpandMoreLess
            className='mb--4'
            name={
                `[${nameListaMoreLess}][${pesquisaIndexList(listaMoreLess,
                    idListaMoreLess)}].expanded`
            }
            item={pesquisaList(listaMoreLess, idListaMoreLess)}
            lista={listaMoreLess}
            setFieldValue={setFieldValue}
        />
    )
}

export const CardGridEstudoPadraoBase = ( {label, component, overflowX, popup, grafico, graficoTitle, tabela, tabelaTitle, naoExibirTabela,
    detalhesCalculo, GridContainerEstudoPadrao, modoApresentacao, nameListaMoreLess, listaMoreLess, idListaMoreLess,
        setFieldValue, aiFTOrigem, variaveisGlobais, values, estudo, vars} ) => {

    const DivCardGridEstudoPadrao = overflowX ? DivOverflowXTabelaPadrao : DivFormEstudo

    const Button = () => {

        return (
            <div
                //className={label === HARDCODE.modoApresentacaoRelatorio ? 'mt-5' : ''}
            >
                {grafico && (
                    <CustomizedDialogsPopup
                        maxWidth='lg'
                        popupTitle={graficoTitle}
                        PopupButton={ButtonVisualizarGrafico}
                        popupComponent={grafico}
                    />
                )}
                {tabela && !naoExibirTabela && (
                    <CustomizedDialogsPopup
                        maxWidth='lg'
                        popupTitle={tabelaTitle}
                        PopupButton={ButtonVisualizarTabela}
                        popupComponent={tabela}
                    />
                )}
                {detalhesCalculo && (
                    <CustomizedDialogsPopup
                        maxWidth='lg'
                        popupTitle={LABEL.buttonDetalhesCalculo}
                        PopupButton={ButtonDetalhesCalculo}
                        popupComponent={detalhesCalculo}
                    />
                )}
            </div>
        )
    }



    const CardGridEstudoAux = modoApresentacao ? GridItem12 : CardGridEstudo
     
    

    return (
        <GridContainerEstudoPadrao
            component={
                popup
                    ?
                        <DivCardGridEstudoPadrao>
                            {component}
                        </DivCardGridEstudoPadrao>
                    :
                        label === HARDCODE.modoApresentacaoRelatorio
                            ?
                                <DivCardGridEstudoPadrao>
                                    <GridContainer>
                                        <GridItem10/>
                                    
                                        <GridItem2>
                                            <Button/>
                                        </GridItem2>
                                    </GridContainer>

                                    <GridContainer
                                        className='mt-3'
                                    >
                                        <GridItem12>
                                            {component}
                                        </GridItem12>
                                    </GridContainer>
                                </DivCardGridEstudoPadrao>
                            :
                                <div
                                    className={modoApresentacao ? 'mt--5' : ''}
                                >
                                    <CardGridEstudoAux>
                                        {label && (
                                            <CardGridDivHeaderDestaque1
                                                semBackground={modoApresentacao}
                                            >
                                                <GridContainer>
                                                    <GridItem8
                                                        className={grafico || (tabela && !naoExibirTabela) || detalhesCalculo ? 'mt-2' : ''}
                                                    >
                                                        <CardGridDivH4Destaque>
                                                            {label === HARDCODE.modoApresentacaoRelatorio ? '' : label}
                                                        </CardGridDivH4Destaque>
                                                    </GridItem8>
                                                
                                                    <GridItem4>
                                                        <GridContainer>
                                                            <GridItem6>
                                                                {(!nameListaMoreLess || listaMoreLess[pesquisaIndexList(
                                                                listaMoreLess, idListaMoreLess)].expanded) && (
                                                                    <Button/>
                                                                )}
                                                            </GridItem6>

                                                            <GridItem3
                                                                className={
                                                                    grafico || (tabela && !naoExibirTabela) || detalhesCalculo
                                                                        ?
                                                                            'mt-1'
                                                                        :
                                                                            ''
                                                                }
                                                            >
                                                                {aiFTOrigem &&
                                                                vars.linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' && (
                                                                    <AIFT
                                                                        aiFTOrigem={aiFTOrigem}
                                                                        variaveisGlobais={variaveisGlobais}
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        vars={vars}
                                                                    />
                                                                )}

                                                            </GridItem3>

                                                            <GridItem3>
                                                                {!modoApresentacao && nameListaMoreLess && (
                                                                    <IconButtonExpandMoreLessLista
                                                                        nameListaMoreLess={nameListaMoreLess}
                                                                        listaMoreLess={listaMoreLess}
                                                                        idListaMoreLess={idListaMoreLess}
                                                                        setFieldValue={setFieldValue}
                                                                    />
                                                                )}
                                                            </GridItem3>
                                                        </GridContainer>
                                                    </GridItem4>
                                                </GridContainer>
                                            </CardGridDivHeaderDestaque1>
                                        )}

                                        {(!nameListaMoreLess || modoApresentacao ||
                                        listaMoreLess[pesquisaIndexList(listaMoreLess, idListaMoreLess)].expanded) && (
                                            <CardGridDivBody>
                                                <DivCardGridEstudoPadrao>
                                                    {component}
                                                </DivCardGridEstudoPadrao>
                                            </CardGridDivBody>
                                        )}
                                    </CardGridEstudoAux>
                                </div>
            }
        />
    )
}

export const CardGridEstudoPadrao = ( {label, component, overflowX, popup, grafico, graficoTitle, tabela, tabelaTitle, naoExibirTabela,
    detalhesCalculo, modoApresentacao, nameListaMoreLess, listaMoreLess, idListaMoreLess, setFieldValue, aiFTOrigem, variaveisGlobais,
        values, estudo, vars} ) => {

    return (
        <CardGridEstudoPadraoBase
            label={label}
            component={component}
            overflowX={overflowX}
            popup={popup}
            grafico={grafico}
            graficoTitle={graficoTitle}
            tabela={tabela}
            tabelaTitle={tabelaTitle}
            naoExibirTabela={naoExibirTabela}
            detalhesCalculo={detalhesCalculo}
            GridContainerEstudoPadrao={GridContainerEstudoPadraoLg}
            modoApresentacao={modoApresentacao}
            nameListaMoreLess={nameListaMoreLess}
            listaMoreLess={listaMoreLess}
            idListaMoreLess={idListaMoreLess}
            setFieldValue={setFieldValue}
            aiFTOrigem={aiFTOrigem}
            variaveisGlobais={variaveisGlobais}
            values={values}
            estudo={estudo}
            vars={vars}
        />
    )
}

export const CardGridEstudoPadraoMd = ( {label, component, overflowX, popup, grafico, graficoTitle, tabela, tabelaTitle, naoExibirTabela,
    detalhesCalculo, modoApresentacao, nameListaMoreLess, listaMoreLess, idListaMoreLess, setFieldValue} ) => {

    return (
        <CardGridEstudoPadraoBase
            label={label}
            component={component}
            overflowX={overflowX}
            popup={popup}
            grafico={grafico}
            graficoTitle={graficoTitle}
            tabela={tabela}
            tabelaTitle={tabelaTitle}
            naoExibirTabela={naoExibirTabela}
            detalhesCalculo={detalhesCalculo}
            GridContainerEstudoPadrao={GridContainerEstudoPadraoMd}
            modoApresentacao={modoApresentacao}
            nameListaMoreLess={nameListaMoreLess}
            listaMoreLess={listaMoreLess}
            idListaMoreLess={idListaMoreLess}
            setFieldValue={setFieldValue}
        />
    )
}

export const CardGridEstudoTabelaPadrao = ( {values, SvgIcon, label, helpTextMorte, helpTextInvalidez, component, popup,
    nameListaMoreLess, listaMoreLess, idListaMoreLess, setFieldValue} ) => {

    const GridItemTabelaPadrao = SvgIcon ? GridItem11sm10xs10 : GridItem12
    const GridItemLabel = !popup && !values.modoApresentacao && nameListaMoreLess ? GridItem10 : GridItem12

    return (
        <>
            {label && (
                <CardGridDivHeaderDestaque1>
                    <GridContainer>
                        {SvgIcon && (
                            <GridItem1sm2xs2>
                                <SvgIcon
                                    fontSize="medium"
                                />
                            </GridItem1sm2xs2>
                        )}

                        <GridItemTabelaPadrao>
                            <GridContainer>
                                <GridItemLabel>
                                    <CardGridDivH4Destaque>
                                        <span
                                            dangerouslySetInnerHTML={{__html: label}}
                                        />
                                    </CardGridDivH4Destaque>

                                    {helpTextMorte && (
                                        <EstudoFormHelp
                                            values={values}
                                            helpTextMorte={helpTextMorte}
                                            helpTextInvalidez={helpTextInvalidez}
                                        />
                                    )}
                                </GridItemLabel>

                                {!popup && !values.modoApresentacao && nameListaMoreLess &&(
                                    <GridItem2>
                                        <IconButtonExpandMoreLessLista
                                            nameListaMoreLess={nameListaMoreLess}
                                            listaMoreLess={listaMoreLess}
                                            idListaMoreLess={idListaMoreLess}
                                            setFieldValue={setFieldValue}
                                        />
                                    </GridItem2>
                                )}
                            </GridContainer>
                        </GridItemTabelaPadrao>
                    </GridContainer>
                </CardGridDivHeaderDestaque1>
            )}
                
            {!popup && (values.modoApresentacao || !nameListaMoreLess ||
            listaMoreLess[pesquisaIndexList(listaMoreLess, idListaMoreLess)].expanded) && (
                <CardGridDivBody>
                    <DivOverflowXTabelaPadrao>
                        {component}
                    </DivOverflowXTabelaPadrao>
                </CardGridDivBody>
            )}

            {popup && (
                <DivOverflowXTabelaPadrao>
                    {component}
                </DivOverflowXTabelaPadrao>
            )}
    </>
    )
}

export const CustomizedDialogsPopupCotacao = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, vars,
    setExpandiu }) => {

    return (
        <div
            className={existeTabelaEvolucaoValorResgate(values) ? 'mb-1' : 'mb-5'}
        >
            <CustomizedDialogsPopup
                maxWidth="lg"
                popupTitle={LABEL.cotacao}
                PopupButton={ButtonDetalhesCotacaoSeguroVidaSucessaoVitalicia}
                popupComponent={
                    <div
                        className='bg-default'
                    >
                        <div
                            className='ml-4 mr-4'
                        >
                            <GridContainer>
                                <GridItem12
                                    className='mt-2'
                                >
                                    <AcompanhamentoFormSeguroVida
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        handleChange={handleChange}
                                        handleSubmit={handleSubmit}
                                        setFieldValue={setFieldValue}
                                        vars={vars}
                                        popupCotacao={true}
                                        popupApolice={false}
                                    />
                                </GridItem12>
                            </GridContainer>
                        </div>
                    </div>
                }
                open={setExpandiu}
                afterClose={setExpandiu}
            />
        </div>
    )
}